(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = true;
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["terplax-auxiliary-feature"]) return;
  try {
    
if (!customElements.get('tplx-auxiliary-backdrop')) {
  customElements.define('tplx-auxiliary-backdrop', class extends HTMLElement {
    connectedCallback() {
      if (this.finished || this.controller || !('IntersectionObserver' in window)) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      const preferences = matchMedia('(prefers-reduced-motion: reduce), (forced-colors: active)');
      let visible = false;
      const finish = () => {
        this.finished = true;
        this.removeAttribute('data-started');
        this.removeAttribute('data-running');
        this.observer?.disconnect();
        this.controller.abort();
      };
      const sync = () => {
        if (preferences.matches) {
          finish();
          return;
        }
        const running = visible && !document.hidden;
        if (running) this.setAttribute('data-started', '');
        this.toggleAttribute('data-running', running);
      };
      this.observer = new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting && entry.intersectionRatio > 0;
        sync();
      }, { threshold: 0 });
      this.addEventListener('animationend', (event) => {
        if (event.animationName === 'tplx-auxiliary-plane-enter') finish();
      }, { signal });
      document.addEventListener('visibilitychange', sync, { signal });
      preferences.addEventListener('change', sync, { signal });
      if (preferences.matches) finish();
      else this.observer.observe(this.parentElement);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
      this.finished = true;
      this.removeAttribute('data-started');
      this.removeAttribute('data-running');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["terplax-flavor-trending"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const track = root.querySelector('[data-track]');
    const prev = root.querySelector('[data-prev]');
    const next = root.querySelector('[data-next]');
    const bar = root.querySelector('[data-bar]');
    if (!track || !track.firstElementChild) return;
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    const gap = () => parseFloat(getComputedStyle(track).columnGap) || 0;
    const step = () => track.firstElementChild.getBoundingClientRect().width + gap();
    const page = () => Math.max(1, Math.floor((track.clientWidth + gap()) / step())) * step();
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
      const ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
      bar.style.width = (ratio * 100) + '%';
      bar.style.left = (max > 0 ? (track.scrollLeft / max) * (100 - ratio * 100) : 0) + '%';
    };
    prev.addEventListener('click', () => track.scrollBy({ left: -page(), behavior: calm }));
    next.addEventListener('click', () => track.scrollBy({ left: page(), behavior: calm }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); next.click(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); prev.click(); }
    });
    let down = false, moved = false, startX = 0, startLeft = 0;
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
    });
    window.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }
      if (moved) track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', () => {
      if (!down) return;
      down = false;
      if (moved) {
        track.classList.remove('is-dragging');
        track.scrollTo({ left: Math.round(track.scrollLeft / step()) * step(), behavior: calm });
      }
    });
    track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); moved = false; } }, true);
    update();
    window.addEventListener('load', update);
  }
  document.querySelectorAll('[data-tfr]').forEach(init);
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-tfr]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["terplax-shop-browser"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('terplax-shop-browser')) {
  customElements.define('terplax-shop-browser', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('[data-drawer]');
      this.panel = this.querySelector('[data-panel]');
      this.sidebar = this.querySelector('[data-sidebar]');
      this.trigger = this.querySelector('[data-open]');
      if (!this.dialog?.showModal || !this.panel || !this.trigger) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      for (const image of this.querySelectorAll('.tp-shop-browser__image--alternate')) {
        const ready = () => image.toggleAttribute('data-ready', image.complete && image.naturalWidth > 0);
        image.addEventListener('load', ready, { signal });
        image.addEventListener('error', () => image.removeAttribute('data-ready'), { signal });
        ready();
      }
      this.setupQuotes(signal);
      const sort = this.querySelector('.tp-shop-browser__sort select');
      if (sort?.form?.requestSubmit) {
        this.querySelector('[data-sort-apply]').hidden = true;
        sort.addEventListener('change', () => sort.form.requestSubmit(), { signal });
      }
      const filterToggle = this.querySelector('[data-toggle-filters]');
      if (filterToggle) {
        filterToggle.hidden = false;
        filterToggle.addEventListener('click', () => {
          const hidden = this.toggleAttribute('data-filters-hidden');
          filterToggle.setAttribute('aria-expanded', String(!hidden));
          filterToggle.textContent = hidden ? filterToggle.dataset.showLabel : filterToggle.dataset.hideLabel;
        }, { signal });
      }
      this.querySelector('.tp-shop-browser__search')?.addEventListener('formdata', (event) => {
        const term = String(event.formData.get('q') || '').trim();
        const escaped = term.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        event.formData.set('q', `title:"${escaped}" OR variants.sku:"${escaped}"`);
      }, { signal });
      const desktop = matchMedia('(min-width: 900px)');
      this.setAttribute('data-enhanced', '');
      this.trigger.hidden = false;
      this.trigger.addEventListener('click', () => {
        if (desktop.matches || this.dialog.open) return;
        this.dialog.append(this.panel);
        this.dialog.showModal();
        this.dialog.querySelector('[data-close]').focus();
      }, { signal });
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog.addEventListener('close', () => {
        this.sidebar.append(this.panel);
        if (!desktop.matches) this.trigger.focus();
      }, { signal });
      desktop.addEventListener('change', () => {
        if (desktop.matches && this.dialog.open) {
          this.dialog.close();
          this.sidebar.append(this.panel);
          if (this.hasAttribute('data-filters-hidden')) filterToggle?.focus();
          else this.panel.querySelector('a, input:not([disabled]), button')?.focus();
        }
      }, { signal });
    }

    setupQuotes(signal) {
      const number = (this.dataset.whatsappNumber || '').trim().replace(/^\+/, '').replace(/[\s()-]/g, '');
      if (!/^[1-9]\d{6,14}$/.test(number)) return;
      for (const card of this.querySelectorAll('[data-quote-card]')) {
        const controls = card.querySelector('[data-quote-controls]');
        const select = card.querySelector('[data-variant]');
        const quantity = card.querySelector('[data-quantity]');
        const link = card.querySelector('[data-quote-link]');
        if (!controls || !select?.options.length || !quantity || !link) continue;
        const restoredAttributes = ['href', 'target', 'rel', 'aria-label', 'aria-disabled', 'data-terplax-event', 'data-terplax-intent', 'data-terplax-placement'];
        const originalAttributes = restoredAttributes.map((name) => [name, link.getAttribute(name)]);
        const originalLabel = link.textContent;
        this.quoteCleanup ||= [];
        this.quoteCleanup.push(() => {
          controls.hidden = true;
          quantity.setCustomValidity('');
          link.textContent = originalLabel;
          for (const [name, value] of originalAttributes) {
            if (value === null) link.removeAttribute(name);
            else link.setAttribute(name, value);
          }
          delete card.dataset.variantId;
          delete card.dataset.variantTitle;
        });
        controls.hidden = false;
        // Keep analytics context, but omit data-terplax-contact-link: the global updater overwrites quote text.
        link.dataset.terplaxEvent = 'whatsapp_quote_click';
        link.dataset.terplaxIntent = 'product_quote';
        link.dataset.terplaxPlacement = 'shop_browser_card';
        link.textContent = link.dataset.quoteLabel;
        link.setAttribute('aria-label', link.dataset.quoteLabel + ': ' + card.dataset.productTitle);
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        const validQuantity = () => {
          const value = Number(quantity.value);
          return quantity.value.trim() !== '' && Number.isSafeInteger(value) && value >= 1;
        };
        const update = () => {
          const valid = validQuantity();
          quantity.setCustomValidity(valid ? '' : link.dataset.invalidQty);
          card.querySelector('[data-step="-1"]').disabled = !valid || Number(quantity.value) <= 1;
          if (!valid) {
            link.href = card.dataset.productUrl;
            link.setAttribute('aria-disabled', 'true');
            return;
          }
          link.removeAttribute('aria-disabled');
          const option = select.selectedOptions[0];
          card.dataset.variantId = option.value;
          card.dataset.variantTitle = option.textContent.trim();
          const productUrl = new URL(card.dataset.productUrl, location.origin);
          productUrl.searchParams.set('variant', option.value);
          const lines = [
            link.dataset.quoteIntro,
            link.dataset.productLabel + ': ' + card.dataset.productTitle,
            link.dataset.variantLabel + ': ' + option.textContent.trim(),
            link.dataset.qtyLabel + ': ' + quantity.value
          ];
          if (option.dataset.sku) lines.push(link.dataset.skuLabel + ': ' + option.dataset.sku);
          lines.push(productUrl.href);
          const destination = new URL('https://wa.me/' + number);
          destination.searchParams.set('text', lines.join('\n'));
          link.href = destination.href;
        };
        controls.addEventListener('input', update, { signal });
        controls.addEventListener('change', update, { signal });
        for (const button of controls.querySelectorAll('[data-step]')) {
          button.addEventListener('click', () => {
            quantity.value = validQuantity()
              ? String(Math.max(1, Math.min(Number.MAX_SAFE_INTEGER, Number(quantity.value) + Number(button.dataset.step))))
              : '1';
            update();
          }, { signal });
        }
        link.addEventListener('click', (event) => {
          update();
          if (!validQuantity()) {
            event.preventDefault();
            quantity.reportValidity();
          }
        }, { signal });
        update();
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      for (const cleanup of this.quoteCleanup || []) cleanup();
      this.quoteCleanup = [];
      const sortApply = this.querySelector('[data-sort-apply]');
      if (sortApply) sortApply.hidden = false;
      if (this.dialog?.open) this.dialog.close();
      if (this.sidebar && this.panel) this.sidebar.append(this.panel);
      this.removeAttribute('data-enhanced');
      this.removeAttribute('data-filters-hidden');
      const toggle = this.querySelector('[data-toggle-filters]');
      if (toggle) {
        toggle.hidden = true;
        toggle.setAttribute('aria-expanded', 'true');
        toggle.textContent = toggle.dataset.hideLabel;
      }
      if (this.trigger) this.trigger.hidden = true;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["terplax-video-hero"] && !Shopify.designMode) return;
  try {
    
function setupTerplaxVideoHero(root){
 root.querySelectorAll('.tplx-video-hero').forEach(hero=>{
 if(hero.dataset.videoReady)return;hero.dataset.videoReady='true';
 const video=hero.querySelector('video'),button=hero.querySelector('button'),reduce=matchMedia('(prefers-reduced-motion: reduce)');
 const play=()=>{if(!video.dataset.videoSrc)return;if(!video.src)video.src=video.dataset.videoSrc;video.play().catch(()=>{button.textContent=button.dataset.playLabel})};
 video.addEventListener('play',()=>button.textContent=button.dataset.pauseLabel);
 video.addEventListener('pause',()=>button.textContent=button.dataset.playLabel);
 button.addEventListener('click',()=>video.paused?play():video.pause());
 reduce.addEventListener('change',e=>{if(e.matches)video.pause()});
 if(!reduce.matches)play();
 });
}
setupTerplaxVideoHero(document);
document.addEventListener('shopify:section:load',e=>setupTerplaxVideoHero(e.target));

  } catch(e) { console.error(e); }
})();
})();
